import { createAction, props, union } from '@ngrx/store';
import { AnalyticsEntry } from 'app/api/analytics.api.service';

const source = 'analytics';
const actions = 'ui';

export const analyticsSetSelectedTab = createAction(
    `[${source}][${actions}] Set Selected Tab`,
    props<{ selectedTab: number }>()
);
export const analyticsReportSetSelectedGroup = createAction(
    `[${source}][${actions}] Report Set Selected Group`,
    props<{ entry: AnalyticsEntry }>()
);

const all = union({
    analyticsSetSelectedTab,
    analyticsReportSetSelectedGroup,
});
export type AnalyticsUIActionsUnion = typeof all;
